module.exports = __webpack_public_path__ + "static/media/genezio.0e5b904d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/Tracks/img/partners/genezio.png
// module id = 260
// module chunks = 0